import * as React from 'react';
import { LocationApiResponse } from '../../../types/location';
import { Button, ButtonVariant } from '../../elements/Button';
import { useNavigate } from 'react-router-dom';
import pluralize from 'pluralize';

interface LocationsImportReportTableProps {
  createdLocations?: LocationApiResponse[];
  updatedLocations?: LocationApiResponse[];
}

const LocationsImportReportTable: React.FC<LocationsImportReportTableProps> = ({
  createdLocations,
  updatedLocations,
}) => {
  return (
    <div className='overflow-auto max-h-[500px] w-full mx-auto shadow-md bg-white rounded-lg mb-10'>
      <table className='w-full text-sm text-left text-gray-dark transition-all'>
        <thead className='text-xs font-normal text-gray-dark bg-gray-disabled border-b border-gray-light'>
          <tr>
            <th className='px-6 py-4 w-2/6'>Type</th>
            <th className='px-6 py-4'>Locations</th>
          </tr>
        </thead>
        <tbody>
          {!!createdLocations?.length && (
            <TableRow
              label={`New ${pluralize(
                'Location',
                createdLocations.length,
              )} Created`}
              data={createdLocations.map((createdLocation) => ({
                ...createdLocation,
                dataTestId: `created-location-${createdLocation.name}`,
              }))}
            />
          )}
          {!!updatedLocations?.length && (
            <TableRow
              label={`Existing ${pluralize(
                'Location',
                updatedLocations.length,
              )} Updated`}
              data={updatedLocations.map((updatedLocation) => ({
                ...updatedLocation,
                dataTestId: `updated-location-${updatedLocation.name}`,
              }))}
            />
          )}
        </tbody>
      </table>
    </div>
  );
};

interface TableRowProps {
  label: string;
  data?: { name: string; id: string | number; dataTestId: string }[];
  isClickDisabled?: boolean;
}

export const TableRow: React.FC<TableRowProps> = ({
  label,
  data,
  isClickDisabled,
}) => {
  const navigate = useNavigate();

  return (
    <tr className='border-t border-gray-300'>
      <td className='px-6 py-4'>{label}</td>
      <td className='px-6 py-4'>
        <div className='flex flex-wrap'>
          {data &&
            data.map((el) => (
              <Button
                dataTestId={el.dataTestId}
                key={el.id}
                variant={ButtonVariant.Default}
                label={el.name}
                onClick={() => {
                  if (!isClickDisabled) {
                    navigate('locations/' + el.id);
                  }
                }}
                className='mr-2 mb-2'
              />
            ))}
        </div>
      </td>
    </tr>
  );
};

export default LocationsImportReportTable;
